export const STATUS_PAGE_URL = "https://status.rivetai.com";

export type MaintenanceDetails = {
  title?: string;
  message?: string;
  endAt?: string;
  statusPageUrl?: string;
};

type NestedPayload = {
  code?: string;
  message?: string;
  data?: {
    title?: string;
    message?: string | null;
    endAt?: string;
    statusPageUrl?: string;
  };
};

export function parseMaintenanceDetails(payload: unknown): MaintenanceDetails | undefined {
  if (!payload || typeof payload !== "object") {
    return undefined;
  }
  const body = payload as NestedPayload;
  const data = body.data;
  if (!data || typeof data !== "object") {
    return undefined;
  }
  const title = typeof data.title === "string" ? data.title : undefined;
  const message =
    typeof data.message === "string" && data.message.trim()
      ? data.message
      : typeof body.message === "string"
        ? body.message
        : undefined;
  const endAt = typeof data.endAt === "string" ? data.endAt : undefined;
  const statusPageUrl =
    typeof data.statusPageUrl === "string" ? data.statusPageUrl : STATUS_PAGE_URL;

  if (!title && !message && !endAt) {
    return { statusPageUrl };
  }
  return { title, message, endAt, statusPageUrl };
}

export function formatMaintenanceEndLabel(endAt: string | undefined): string | undefined {
  if (!endAt) return undefined;
  const d = new Date(endAt);
  if (Number.isNaN(d.getTime())) return undefined;
  return d.toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  });
}
